// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1qHz-","consentsList":"PatientConsents_consentsList__rrSi1","consentsListEmpty":"PatientConsents_consentsListEmpty__2bBlv"};